import React, { useEffect, useRef } from 'react';
import Section from '../../components/common/Section';

/**
 * 客户案例展示页面
 * 展示成功客户的案例和故事
 */
const CustomerCasesPage: React.FC = () => {

  const allCases = [
    { id: 'ecommerce-1', title: '优选电商', imageUrl: '/assets/images/features/meeting-notes.svg', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'ecommerce-2', title: '全球购物', imageUrl: '/assets/images/features/work.png', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'ecommerce-3', title: '时尚优品', imageUrl: '/assets/images/products/dengbaba.png', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'food-1', title: '品味餐厅', imageUrl: '/assets/images/features/meeting-notes.svg', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'food-2', title: '快乐咖啡', imageUrl: '/assets/images/features/work.png', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'food-3', title: '鲜果饮品', imageUrl: '/assets/images/products/dengbaba.png', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'retail-1', title: '优家生活', imageUrl: '/assets/images/features/meeting-notes.svg', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'retail-2', title: '时代百货', imageUrl: '/assets/images/features/work.png', qrUrl: '/assets/images/qrcode.jpg' },
    { id: 'retail-3', title: '全球优选', imageUrl: '/assets/images/products/dengbaba.png', qrUrl: '/assets/images/qrcode.jpg' }
  ];

  const containerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    const onScroll = () => {
      const el = containerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(1, Math.max(0, 1 - rect.top / vh));
      const range = 60;
      for (const item of itemRefs.current) {
        if (!item) continue;
        const speed = Number(item.dataset.speed || 1);
        const offset = speed * progress * range;
        item.style.transform = `translateY(${offset}px)`;
        item.style.willChange = 'transform';
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="customer-cases-page">
      {/* 页面标题 */}
      <Section
        id="cases-header"
        spacing="medium"
        background="white"
        className="border-b border-gray-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-8 md:py-12">
            <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4">
              客户案例
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              看看我们如何帮助客户取得成功
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              这些成功案例展示了我们如何帮助各行业客户解决问题、提升效率、实现业务增长
            </p>
          </div>
        </div>
      </Section>

      <Section id="cases-masonry" spacing="large" background="white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={containerRef}>
          <div className="columns-1 md:columns-3 gap-6">
            {allCases.map((c, i) => (
              <div
                key={c.id}
                ref={(el) => {
                  if (el) itemRefs.current[i] = el;
                }}
                data-speed={i % 3 === 1 ? -1 : 1}
                className="group relative overflow-hidden mb-6 [break-inside:avoid]"
              >
                <img src={c.imageUrl} alt={c.title} className="w-full h-auto" />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="bg-white rounded-xl p-4 shadow-md flex items-center gap-4">
                    <img src={c.qrUrl} alt="小程序二维码" className="w-24 h-24 rounded-md" />
                    <div className="text-gray-900">
                      <div className="font-bold">{c.title}</div>
                      <div className="text-sm text-gray-600">扫码体验</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>



    </div>
  );
};

export default CustomerCasesPage;
